var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLegend)?_c('div',{staticClass:"legend-box"},[_c('div',{staticClass:"legend-title"},[_vm._v(" 图例 ")]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend-container"},[_c('div',{staticClass:"legend-item"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/image/legend.png")}})])])])
}]

export { render, staticRenderFns }